export default "__VITE_ASSET__DljHoY33__"